<script>
  // Queue hrefs mirror each list page's own `mode` param. Deliberately quiet:
  // the only colour is the overdue tag, and it turns red only at 72h+.
  import { Link } from '@inertiajs/svelte'
  import { Icon } from '../../components/ui'

  let { queue = {} } = $props()

  const cards = $derived(
    [
      queue.moment_reviews && { key: 'moments', title: 'Flagged Moments', icon: 'moments', section: queue.moment_reviews, href: '/moments?mode=flagged' },
      queue.user_reviews && { key: 'users', title: 'User Reports', icon: 'user_reports', section: queue.user_reviews, href: '/user-reports?mode=needs_review' },
      queue.quest_submissions && {
        key: 'quests',
        title: 'Quest Submissions',
        icon: 'quest_submissions',
        section: queue.quest_submissions,
        href: '/quest-submissions?mode=pending'
      }
    ].filter(Boolean)
  )
</script>

<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
  {#each cards as card (card.key)}
    <Link href={card.href} class="block">
      <div
        class="card bg-base-100 border shadow-sm hover:shadow-md transition-shadow h-full {card.section.pending_count > 0
          ? 'border-base-content/30'
          : 'border-base-300'}"
      >
        <div class="card-body gap-1">
          <h2 class="card-title text-base">
            <Icon name={card.icon} size="sm" />
            {card.title}
          </h2>
          <div class="text-3xl font-bold">{card.section.pending_count.toLocaleString()}</div>
          <div class="text-sm text-base-content/60 flex items-center gap-2">
            <span>
              {card.section.oldest_waiting_label ? `Oldest waiting ${card.section.oldest_waiting_label}` : 'Queue clear'}
            </span>
            {#if card.section.overdue_count > 0}
              <span
                class="inline-flex items-center gap-0.5 font-semibold {card.section.critical
                  ? 'text-error'
                  : 'text-base-content/60'}"
                title={`${card.section.overdue_count} waiting more than a day`}
              >
                <Icon name="waiting" size="xs" />
                {card.section.overdue_count}
              </span>
            {/if}
          </div>
        </div>
      </div>
    </Link>
  {/each}
</div>
